export const THEME = {
  colors: {
    primary: '#4CAF50',
    secondary: '#6B7280',
    border: '#E5E7EB',
    error: '#DC2626',
    text: {
      primary: '#374151',
      secondary: '#6B7280',
      error: '#DC2626'
    },
    background: {
      primary: '#FFFFFF',
      secondary: '#F9FAFB',
      error: '#FEE2E2'
    }
  },
  spacing: {
    xs: '4px',
    sm: '8px',
    md: '16px',
    lg: '24px',
    xl: '32px'
  }
};